import { ISedmsFormModel } from 'src/app/shared/interfaces/form/sedms-form-model';
import { validateEmail, validateName, validatePhoneNumberMaskedTextBox } from '../../validators/validator';

export const AddStudentRelatedEventFormModel: ISedmsFormModel = {
    evaluationSk: {
        name: 'evaluationSk',
    },
    relatedAction: {
        name: 'relatedAction',
    },
    relatedActionOther: {
        name: 'relatedActionOther',
    },
    eIOutreachToFromOther:{
        name :'eIOutreachToFromOther'
    },
    eIOutreachToFrom:{
        name:'eIOutreachToFrom',
    },
    relatedActionDate: {
        name: 'relatedActionDate',
    },
    previousAttempts: {
        name: 'previousAttempts',
    },
    dateOccurred: {
        name: 'dateOccurred',
    },
    timeOccurred: {
        name: 'timeOccurred',
    },
    from: {
        name: 'from',
        validators: [{validator: validateName(false)}]
    },
    to: {
        name: 'to',
        validators: [{validator: validateName(false)}]
    },

    contactMethod: {
        name: 'contactMethod',
    },
    toPhone: {
        name: 'toPhone',
        validators: [{validator: validatePhoneNumberMaskedTextBox(false)}]
    },
    responseMethod: {
        name: 'responseMethod',
    },
    engagementStatus: {
        name: 'engagementStatus',
    },
    notes: {
        name: 'notes',
    },
    language: {
        name: 'language',
    },
    languageSupportProvided: {
        name: 'languageSupportProvided',
    },
    toPostalAddress: {
        name: 'toPostalAddress',
    },
    toEmailAddress: {
        name: 'toEmailAddress',
        validators: [{validator: validateEmail(false)}]
    },
    logEventFile: {
        name: 'logEventFile',
    },


    fromPhone: {
        name: 'fromPhone',
        validators: [{validator: validatePhoneNumberMaskedTextBox(false)}]
    },
    fromPostalAddress: {
        name: 'fromPostalAddress',
    },
    fromEmailAddress: {
        name: 'fromEmailAddress',
        validators: [{validator: validateEmail(false)}]
    }


}